import { getCashMetadata } from './factories';

export const getCashPropertiesRequested = getCashMetadata('propertiesRequested');
export const getCashIsEspTieringDefault = getCashMetadata('isEspDefaultTiering');
export const getCashRfsStreamId = getCashMetadata('currentStreamId');
